import './styles.scss'
import Label from "components/Label";
import PaymentItem from "./PaymentItem";
import { useRef } from 'react';
import { useAnimation } from 'hooks/useAnimation';

const PaymentsSection = ({ payments, isLoading }) => {
    const { tag, title, card } = payments
    const container = useRef();
    useAnimation({
        items: ['.payment h2', '.payment-item'],
        container,
        dependencies: [isLoading],
    })

    return (
        <section ref={container} className="inner-container payment">
            <Label text={tag} />
            <h2>{title}</h2>
            <div className="payment-container">
                {
                    card?.map((item, index) => (
                        <PaymentItem key={index} data={item} />
                    ))
                }
            </div>

        </section>
    );
}

export default PaymentsSection;